import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Tupa from '../../img/speakers/Tupa.png'
import rotary from '../../img/speakers/rotary.png'
import Silanteva from '../../img/speakers/Silanteva.png'
import ASR from '../../img/speakers/ASR.png'
import Aristov from '../../img/speakers/Aristov.png'
import revival from '../../img/speakers/revival.png'
import Ivanenko from '../../img/speakers/Ivanenko.png'
import patient from '../../img/speakers/patient.png'
import Fedorov from '../../img/speakers/Fedorov.png'
import lvivklaster from '../../img/speakers/lvivklaster.png'
import Kyrilovich from '../../img/speakers/Kyrilovich.png'
import upaw from '../../img/speakers/upaw.png'
import Kozura from '../../img/speakers/Kozura.png'
import IPM from '../../img/speakers/IPM.png'
import Podolyak from '../../img/speakers/Podolyak.png'
import pritula_logo from '../../img/speakers/pritula_logo.png'
import Chevganuk from '../../img/speakers/Chevganuk.png'
import uaanimals from '../../img/speakers/uaanimals.png'
import Zatvarskyi from '../../img/speakers/Zatvarskyi.png'
import djmelyk from '../../img/speakers/djmelyk.png'
import Losik from '../../img/speakers/Losik.png'
import azou from '../../img/speakers/azou.png'
import Kovalko from '../../img/speakers/Kovalko.png'
import saveukraine from '../../img/speakers/saveukraine.png'
import Ostrovska from '../../img/speakers/Ostrovska.png'
import dnipro from '../../img/speakers/dnipro.png'
import Pedan from '../../img/speakers/Pedan.png'
import Bogdjaj from '../../img/speakers/Bogdjaj.png'
import dvornjashkam_dom from '../../img/speakers/dvornjashkam_dom.png'
import Marhel from '../../img/speakers/Marhel.png'
import lestdoitukraine from '../../img/speakers/lestdoitukraine.png'
import Onipko from '../../img/speakers/Onipko.png'
import zaporuka from '../../img/speakers/zaporuka.png'
import Maydanuk from '../../img/speakers/Maydanuk.png'
import soloma from '../../img/speakers/soloma.png'
import Mischerjakov from '../../img/speakers/Mischerjakov.png'
import Tatarchuk from '../../img/speakers/Tatarchuk.png'
import tvoja_opora from '../../img/speakers/tvoja_opora.png'
import Gribovsky from '../../img/speakers/Gribovsky.png'
import hub_sos_ua from '../../img/speakers/hub_sos_ua.png'
import Bondarchuk from '../../img/speakers/Bondarchuk.png'
import pechersk from '../../img/speakers/pechersk.png'
import Gerasenko from '../../img/speakers/Gerasenko.png'
import embrace from '../../img/speakers/embrace.png'
import Rimaryk from '../../img/speakers/Rimaryk.png'
import povernis_jivym from '../../img/speakers/povernis_jivym.png'
import Ostapenko from '../../img/speakers/Ostapenko.png'
import brigada from '../../img/speakers/brigada.png'
import Garaeva from '../../img/speakers/Garaeva.png'
import ilysa_razom from '../../img/speakers/ilysa_razom.png'
import Vasylikov from '../../img/speakers/Vasylikov.png'
import Fedchenko from '../../img/speakers/Fedchenko.png'
import Antropov from '../../img/speakers/Antropov.png'
import UHF2 from '../../img/speakers/UHF2.png'
import Lazareva from '../../img/speakers/Lazareva.png'
import TSG from '../../img/speakers/TSG.png'
import Lozova from '../../img/speakers/Lozova.png'
import sirius from '../../img/speakers/sirius.png'
import Chebotaev from '../../img/speakers/Chebotaev.png'
import yazatebe from '../../img/speakers/yazatebe.png'
import Grushko from '../../img/speakers/Grushko.png'
import Mohnev from '../../img/speakers/Mohnev.png'
import mohnev_logo from '../../img/speakers/mohnev_logo.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    block: '10:05 - Панельна дискусія: Військова амуніція',
                },
                {
                    photo: Pedan,
                    name: 'Олександр Педан',
                    position: `Телеведучий, громадський діяч, співзасновник комунікаційної агенції pedan | buro`,
                    fb: 'https://www.facebook.com/pedanos',
                    inst: 'https://www.instagram.com/pedanos/',
                    moderator: true,
                },
                {
                    photo: Fedorov,
                    name: 'Юрій Федоров',
                    position: `Член правління ГО "Львівський Оборонний Кластер". Директор ТОВ "Харківський завод засобів індивідуального захисту"`,
                    fb: 'https://www.facebook.com/uv.fedorov',
                    logo: lvivklaster,
                },
                {
                    photo: Kozura,
                    name: 'Андрій Козюра',
                    position: `Експерт з тактичного спорядження`,
                    inst: 'https://instagram.com/endrunot?igshid=YmMyMTA2M2Y=',
                    logo: IPM,
                },
                {
                    photo: Podolyak,
                    name: 'Меланія Подоляк',
                    position: `Волонтерка Благодійного фонду Сергія Притули`,
                    fb: 'https://www.facebook.com/podolyakmel',
                    logo: pritula_logo,
                },
                {
                    photo: Zatvarskyi,
                    name: 'Іван Затварський',
                    position: `Волонтерський екіпаж оперативного реагування "Джмелик"`,
                    fb: 'https://www.facebook.com/jonathan.zatvarski',
                    logo: djmelyk,
                },
                {
                    photo: Rimaryk,
                    name: 'Андрій Римарук',
                    position: `Керівник військового відділу Фонду компетентної допомоги армії «Повернись живим»`,
                    fb: 'https://www.facebook.com/andrei.rumaryk',
                    logo: povernis_jivym,
                },
                {
                    photo: Ostapenko,
                    name: 'Олександр Остапенко',
                    position: `24 Окрема Механізована Бригада імені Короля Данила`,
                    fb: 'https://www.facebook.com/mcostapenko.live',
                    logo: brigada,
                },
                {
                    photo: Mohnev,
                    name: 'Сергій Мохнєв',
                    position: `Волонтер, директор Благодійного Фонду «Доброго ранку, ми з України»`,
                    ln: 'https://www.linkedin.com/in/serhii-mokhniev',
                    fb: 'https://www.facebook.com/mokhniev',
                    logo: mohnev_logo,
                },
          ],
          listHide: [
            {
                block: '11:00 - Панельна дискусія: Фандрейзинг',
            },
            {
                photo: Pedan,
                name: 'Олександр Педан',
                position: `Телеведучий, громадський діяч, співзасновник комунікаційної агенції pedan | buro`,
                fb: 'https://www.facebook.com/pedanos',
                inst: 'https://www.instagram.com/pedanos/',
                moderator: true,
            },
            {
                photo: Tupa,
                name: 'Оксана Тюпа',
                position: `ГО "Ротарі Клуб Київ Інтерернешенал". Офіцер дистрикту з фандрейзингу`,
                fb: 'https://www.facebook.com/oksana.tjupa/',
                inst: 'https://www.instagram.com/oksana.tjupa/',
                ln: 'https://www.linkedin.com/in/oksanatjupa/',
                logo: rotary,
            },
            {
                photo: Maydanuk,
                name: 'Валентин Майданюк',
                position: `Співзасновник благодійного фонду "Солом'янські котики"`,
                fb: 'https://www.facebook.com/valentyn.maidanyuk',
                logo: soloma,
            },
            {
                photo: Tatarchuk,
                name: 'Валерія Татарчук',
                position: `Засновниця благодійного фонду «Твоя Опора»`,
                inst: 'https://instagram.com/lera_tatarchuk?igshid=YmMyMTA2M2Y=',
                inst2: 'https://instagram.com/tvoyaopora?igshid=YmMyMTA2M2Y=',
                logo: tvoja_opora,
            },
            {
                photo: Gribovsky,
                name: 'Роман Грибовський',
                position: `Координатор НUB SOS-UA`,
                fb: 'https://www.facebook.com/Roman.Grybovskyj',
                logo: hub_sos_ua,
            },
            {
                photo: Garaeva,
                name: 'Єлена Гареєва',
                position: `СОО Ilysa Razom`,
                fb: 'https://www.facebook.com/ElenaGareevart',
                logo: ilysa_razom,
            },
            {
                photo: Antropov,
                name: 'Олександр Антропов',
                position: `СЕО та Фаундер ГО "Об'єднаний Гуманітарний Фронт"`,
                fb: 'https://www.facebook.com/profile.php?id=1657071699',
                inst: 'https://www.instagram.com/sasha.uhf/',
                logo: UHF2,
            },
            {
                photo: Chebotaev,
                name: 'Євгеній Чеботарев',
                position: `Член правління в Міжнародному благодійному фонді «Україно Я за тебе»`,
                fb: 'https://www.facebook.com/eugene.chebotariov',
                logo: yazatebe,
            },
            {
                paneldiscussion: true,
                title: 'Корисні чати для волонтерів',
                time: '12:00',
            },
            {
                block: '13:00 – Панельна дискусія: Ліки',
            },
            {
                photo: Vasylikov,
                name: 'Микола Васильков',
                position: `Український телевізійний ведучий, репортер, журналіст, продюсер`,
                inst: 'https://www.instagram.com/vasmykola/',
                moderator: true,
            },
            {
                photo: Ostrovska,
                name: 'Ганна Островська',
                position: `Медсестра. Інструктор з тактичної та невідкладної допомоги`,
                fb: 'https://www.facebook.com/profile.php?id=100004292238017',
                logo: dnipro,
            },
            {
                photo: Aristov,
                name: 'Вадим Арістов',
                position: `Лікар, стратегічний консультант. Директор Revival Institute. Засновник глобальної медичної ініціативи StingMD`,
                logo: revival,
            },
            {
                photo: Ivanenko,
                name: 'Інна Іваненко',
                position: `Виконавча директорка Благодійного фонду "Пацієнти України"`,
                fb: 'https://www.facebook.com/inna.boyko.37',
                logo: patient,
            },
            {
                photo: Bondarchuk,
                name: 'Геннадій Бондарчук',
                position: `Лікар, медичний радник Айрмед Байотек, волонтер в Печерськ котики`,
                fb: 'https://www.facebook.com/profile.php?id=100000704047933',
                logo: pechersk,
            },
            {
                photo: Fedchenko,
                name: 'Анна Федченко',
                position: `Координаторка  Let’s do it Ukraine в Київській обл`,
                fb: 'https://www.facebook.com/fedchenko.a',
                logo: lestdoitukraine,
            },
            {
                block: '14:00 – Панельна дискусія: Гуманітарна допомога',
            },
            {
                photo: Mischerjakov,
                name: 'Роман Міщеряков',
                position: `Телеведучий, волонтер`,
                inst: 'https://www.instagram.com/misheriakov/',
                moderator: true,
            },
            {
                photo: Kovalko,
                name: 'Мартин Ковалко',
                position: `Співорганізатор ініціативи SaveUkraine.city`,
                fb: 'https://www.facebook.com/martyn.kovalko',
                logo: saveukraine,
            },
            {
                photo: Silanteva,
                name: 'Інна Силантьєва',
                position: `Президент Асоціації соціального розвитку через право`,
                fb: 'https://www.facebook.com/inna.silantieva',
                logo: ASR,
            },
            {
                photo: Marhel,
                name: 'Юлія Мархель',
                position: `Координаторка Міжнародного проєкту гуманітарної допомоги Let's do it Ukraine SOS`,
                fb: 'https://www.facebook.com/julia.marhel',
                logo: lestdoitukraine,
            },
            {
                photo: Onipko,
                name: 'Наталія Оніпко',
                position: `Засновниця та президентка благодійного фонду "Запорука"`,
                fb: 'https://www.facebook.com/onipkonatalia',
                inst: 'https://www.instagram.com/onipko.natalia/',
                logo: zaporuka,
            },
            {
                photo: Gribovsky,
                name: 'Роман Грибовський',
                position: `Координатор НUB SOS-UA`,
                fb: 'https://www.facebook.com/Roman.Grybovskyj',
                logo: hub_sos_ua,
            },
            {
                photo: Gerasenko,
                name: 'Тетяна Герасенко',
                position: `Представник EmbraceMe Foundation в Україні`,
                inst: 'https://instagram.com/embraceme.foundation?igshid=YmMyMTA2M2Y=',
                logo: embrace,
            },
            {
                photo: Lazareva,
                name: 'Алла Лазарєва',
                position: `Заступник директора, керівник по роботі з клієнтами ТОВ Транспорт Сервіс ГРУП УКРАЇНА`,
                logo: TSG,
            },
            {
                block: '15:00 – Панельна дискусія: Тварини',
            },
            {
                photo: Mischerjakov,
                name: 'Роман Міщеряков',
                position: `Телеведучий, волонтер`,
                inst: 'https://www.instagram.com/misheriakov/',
                moderator: true,
            },
            {
                photo: Kyrilovich,
                name: 'Ольга Кирилович',
                position: `Співзасновник ГО "Світова асоціація з питань тварин України"`,
                fb: 'https://www.facebook.com/olga.kirilovich',
                logo: upaw,
            },
            {
                photo: Chevganuk,
                name: 'Ольга Чевганюк',
                position: `Співзасновниця громадської організації UAnimals`,
                fb: 'https://www.facebook.com/olga.chevganiuk',
                logo: uaanimals,
            },
            {
                photo: Losik,
                name: 'Алла Лосік',
                position: `Віце-Президент Асоціації Зоозахисних Організацій України АЗОУ`,
                fb: 'https://www.facebook.com/alla.losik',
                logo: azou,
            },
            {
                photo: Bogdjaj,
                name: 'Крістіна Богдяж',
                position: `Проєктна менеджерка БО «Дворняшкам дом»`,
                inst: 'https://www.instagram.com/dvor_nyashkam_dom/',
                fb: 'https://www.facebook.com/dvor.nyashkam.dom',
                logo: dvornjashkam_dom,
            },
            {
                photo: Lozova,
                name: 'Ірина Лозова',
                position: `Директор притулку для тварин Сіріус`,
                fb: 'https://www.facebook.com/ir.lozova',
                logo: sirius,
            },
            {
                photo: Grushko,
                name: 'Єлизавета Грушко',
                position: `Координатор напрямку тварини в БФ «Україно Я за тебе»`,
                fb: 'https://www.facebook.com/liska4ka',
                logo: yazatebe,
            },
          ],
        }
      }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">РОЗКЛАД</h3>
                    <p className="agenda_undertitle">ВолоСаміту - 30 квітня</p>
                    <VideoPresent speakers={this.state.list} speakersHide={this.state.listHide} />
                    {/* <a className='full_agenda_btn' href='https://geekle.us/schedule/angular22' target='_blank' rel="noreferrer">ПОКАЗАТИ ПОВНИЙ РОЗКЛАД</a> */}
                </div>
            </div>
        );
    }
};